import { createFileRoute } from "@tanstack/react-router";
import { SiteShell, PageHero } from "@/components/site/SiteShell";
import { Section, SectionHeader, FAQ, CTABand, StatRow } from "@/components/site/Blocks";
import { buildHead } from "@/lib/seo-head";

const faqItems = [
  { q: "¿Quién califica como extranjero nacional?", a: "Inversionistas sin residencia permanente ni ciudadanía estadounidense que buscan financiar propiedades de inversión con fines comerciales." },
  { q: "¿Se requiere ITIN o SSN?", a: "Depende del programa. Algunos prestamistas aceptan pasaporte y verificación internacional; otros requieren ITIN." },
  { q: "¿Qué reservas se requieren?", a: "Generalmente 12 meses de PITIA y fondos de cierre documentados, a veces más para extranjeros no residentes." },
  { q: "¿Puedo cerrar en entidad?", a: "Sí, muchos programas permiten LLC estadounidense como prestatario." },
];

export const Route = createFileRoute("/es/prestamos-extranjeros")({
  head: () =>
    buildHead({
      title: "Préstamos para Extranjeros Nacionales | Propiedades de Inversión",
      description:
        "Préstamos para extranjeros nacionales que invierten en propiedades de alquiler en EE.UU. LLC-friendly, sin ingresos estadounidenses documentados donde el programa lo permita.",
      url: "/es/prestamos-extranjeros",
      locale: "es",
      keywords: "préstamos extranjeros nacionales, préstamos inversión extranjeros, financiamiento extranjero propiedad alquiler, préstamos ITIN inversionista",
      breadcrumbs: [
        { name: "Inicio", url: "/es" },
        { name: "Préstamos para extranjeros", url: "/es/prestamos-extranjeros" },
      ],
      service: { name: "Préstamos para extranjeros nacionales" },
      faqs: faqItems,
    }),
  component: ForeignNationalPage,
});

function ForeignNationalPage() {
  return (
    <SiteShell>
      <PageHero eyebrow="Extranjeros nacionales" title="Financiamiento para inversionistas internacionales." subtitle="Préstamos para propiedades de inversión en EE.UU. con documentación internacional y cierre en entidad." />
      <Section>
        <SectionHeader title="Puntos clave" center />
        <StatRow
          items={[
            { label: "Max LTV", value: "75%" },
            { label: "Reservas", value: "12+ meses" },
            { label: "Vestimenta", value: "LLC US" },
            { label: "Verificación", value: "Bancos / ITIN" },
            { label: "Propósito", value: "Inversión" },
            { label: "Renta", value: "Ingreso propiedad" },
          ]}
        />
        <p className="mt-3 text-xs text-muted-foreground">
          Los límites mostrados son de programas elegibles con fines comerciales. La aprobación final
          depende del prestamista mayorista, suscripción y documentación completa.
        </p>
      </Section>
      <Section>
        <div className="mx-auto max-w-4xl">
          <SectionHeader title="Preguntas frecuentes" center />
          <FAQ items={faqItems} />
        </div>
      </Section>
      <CTABand title="¿Invierte desde el extranjero?" body="Envíenos su escenario y le explicamos qué documentos necesita." />
    </SiteShell>
  );
}
